/* Generated by scripts/apply-brand.js from src/data/products.json — do not edit by hand */
import type { Product } from "./productTypes";
import img0 from "../assets/course-cards/mrcog_part_1.jpg";
import img1 from "../assets/course-cards/mrcog_part_2.jpg";

export const BRAND_PRODUCTS: readonly Product[] = [
  {
    "title": "MRCOG Part 1",
    "id": "mrcog_part_1",
    "price": 199,
    "comingSoon": false,
    "description": "1,850+ exam-style questions for the MRCOG Part 1, covering 15 topics, with detailed explanations, performance analytics and timed practice.",
    "length": "6 months",
    "css": "linear-gradient-3",
    "cardImage": "course-cards/mrcog_part_1.jpg",
    "subjectNames": [
      "MRCOG Part 1"
    ]
  },
  {
    "title": "MRCOG Part 2",
    "id": "mrcog_part_2",
    "price": 199,
    "comingSoon": false,
    "description": "1,850+ exam-style questions for the MRCOG Part 2, covering 15 topics, with detailed explanations, performance analytics and timed practice.",
    "length": "6 months",
    "css": "linear-gradient-3",
    "cardImage": "course-cards/mrcog_part_2.jpg",
    "subjectNames": [
      "MRCOG Part 2"
    ]
  }
];

export const CARD_IMAGES: Record<string, string> = {
  "course-cards/mrcog_part_1.jpg": img0,
  "course-cards/mrcog_part_2.jpg": img1,
};
